
const basePlURL = window._env_.VITE_BASE_PL_URL; // PerformLine Server 


export const standardErrCheck = async (resp: Response) => {
    if (!resp.ok) {
        throw new Error(`HTTP error ${resp.status}`);
    }
};

export const _logOut = async () => {
    window.location.href = `${basePlURL}/accounts/v1/logout/`;
};

export function _redirectToLogin(): void {
    window.location.href = `${basePlURL}/login/`;
}

